// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  height: 100vh;
  /* font-family: Arial;
  font-family: Arial, Helvetica, sans-serif; */
  font-family: SourceSansPro-Regular, sans-serif !important;
}

p,
h1,
h2,
h3,
h4,
h5,
h6,
button,
input,
tr,
th,
td,
div {
  font-family: SourceSansPro-Regular, sans-serif !important;
}

h1 {
  text-align: center;
}

.gauge-wrapper {
  display: flex;
  justify-content: center;
  width: auto;
  margin: 0 auto;
  position: relative;
  margin-left: 47px;
  padding-bottom: 15px;
  transform: scale(0.75);
}

.gauge.min-scaled {
  transform: scale(0.5);
}

.gauge-center > * {
  transform: rotate(-80deg);
}

.gauge-center {
  transform: rotate(80deg);
  z-index: 10;
  flex-direction: column;
  content: "";
  color: #fff;
  width: 141px;
  height: 140px;
  background: #000000;
  border-radius: 50%;
  position: absolute;
  box-shadow: 0 -13px 15px -10px rgba(0, 0, 0, 0.28);
  /* right: 67px; */
  top: 50px;
  border: 14px solid;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gauge-center::after {
  content: "";
  top: -26px;
  position: absolute;
  z-index: 10000;
  display: flex;
  justify-content: flex-end;
  left: 53% !important;
  margin-left: -8px;
  border-width: 19px;
  border-style: solid;
  border-color: #000000;
  border-left: 10px solid transparent;
  border-top: 10px solid transparent;
  border-right: 10px solid transparent;
}

.gauge-center .label,
.gauge-center .number {
  display: block;
  width: 100%;
  font-weight: 700;
  font-size: "12px";
  line-height: "14px";
  text-align: center;
  border-radius: 100px 100px 0 0 !important;
  color: #fff;
  border: 0 !important;
}

.gauge-center .label {
  font-size: 0.7em;
  font-weight: 500;
  color: #ffffff;
  margin: 0em 0 0.3em 0;
}

.gauge-center .number {
  font-size: 0.8em;
}

.needle {
  width: 80px;
  height: 7px;
  background: #15222e;
  border-bottom-left-radius: 100% !important;
  border-bottom-right-radius: 5px !important;
  border-top-left-radius: 100% !important;
  border-top-right-radius: 5px !important;
  position: absolute;
  bottom: -2px;
  left: 20px;
  transform-origin: 100% 4px;
  transform: rotate(0deg);
  box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.38);
  display: none;
  z-index: 9;
}

.four.rischio1 .needle {
  animation: fourspeed1 2s 1 both;
  animation-delay: 1s;
  display: block;
}

.four.rischio2 .needle {
  animation: fourspeed2 2s 1 both;
  animation-delay: 1s;
  display: block;
}

.four.rischio3 .needle {
  animation: fourspeed3 2s 1 both;
  animation-delay: 1s;
  display: block;
}

.four.rischio4 .needle {
  animation: fourspeed4 2s 1 both;
  animation-delay: 1s;
  display: block;
}

.MuiGrid-root.none-select::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: #191c1d;
  opacity: 0.7;
}

.MuiGrid-root.none-select {
  background: transparent;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/FuelRatingPage/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb;8CAC4C;EAC5C,yDAAyD;AAC3D;;AAEA;;;;;;;;;;;;;EAaE,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kDAAkD;EAClD,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,uBAAuB;EACvB,6CAA6C;EAC7C,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ","sourcesContent":["body {\r\n  height: 100vh;\r\n  /* font-family: Arial;\r\n  font-family: Arial, Helvetica, sans-serif; */\r\n  font-family: SourceSansPro-Regular, sans-serif !important;\r\n}\r\n\r\np,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nbutton,\r\ninput,\r\ntr,\r\nth,\r\ntd,\r\ndiv {\r\n  font-family: SourceSansPro-Regular, sans-serif !important;\r\n}\r\n\r\nh1 {\r\n  text-align: center;\r\n}\r\n\r\n.gauge-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  width: auto;\r\n  margin: 0 auto;\r\n  position: relative;\r\n  margin-left: 47px;\r\n  padding-bottom: 15px;\r\n  transform: scale(0.75);\r\n}\r\n\r\n.gauge.min-scaled {\r\n  transform: scale(0.5);\r\n}\r\n\r\n.gauge-center > * {\r\n  transform: rotate(-80deg);\r\n}\r\n\r\n.gauge-center {\r\n  transform: rotate(80deg);\r\n  z-index: 10;\r\n  flex-direction: column;\r\n  content: \"\";\r\n  color: #fff;\r\n  width: 141px;\r\n  height: 140px;\r\n  background: #000000;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  box-shadow: 0 -13px 15px -10px rgba(0, 0, 0, 0.28);\r\n  /* right: 67px; */\r\n  top: 50px;\r\n  border: 14px solid;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.gauge-center::after {\r\n  content: \"\";\r\n  top: -26px;\r\n  position: absolute;\r\n  z-index: 10000;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  left: 53% !important;\r\n  margin-left: -8px;\r\n  border-width: 19px;\r\n  border-style: solid;\r\n  border-color: #000000;\r\n  border-left: 10px solid transparent;\r\n  border-top: 10px solid transparent;\r\n  border-right: 10px solid transparent;\r\n}\r\n\r\n.gauge-center .label,\r\n.gauge-center .number {\r\n  display: block;\r\n  width: 100%;\r\n  font-weight: 700;\r\n  font-size: \"12px\";\r\n  line-height: \"14px\";\r\n  text-align: center;\r\n  border-radius: 100px 100px 0 0 !important;\r\n  color: #fff;\r\n  border: 0 !important;\r\n}\r\n\r\n.gauge-center .label {\r\n  font-size: 0.7em;\r\n  font-weight: 500;\r\n  color: #ffffff;\r\n  margin: 0em 0 0.3em 0;\r\n}\r\n\r\n.gauge-center .number {\r\n  font-size: 0.8em;\r\n}\r\n\r\n.needle {\r\n  width: 80px;\r\n  height: 7px;\r\n  background: #15222e;\r\n  border-bottom-left-radius: 100% !important;\r\n  border-bottom-right-radius: 5px !important;\r\n  border-top-left-radius: 100% !important;\r\n  border-top-right-radius: 5px !important;\r\n  position: absolute;\r\n  bottom: -2px;\r\n  left: 20px;\r\n  transform-origin: 100% 4px;\r\n  transform: rotate(0deg);\r\n  box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.38);\r\n  display: none;\r\n  z-index: 9;\r\n}\r\n\r\n.four.rischio1 .needle {\r\n  animation: fourspeed1 2s 1 both;\r\n  animation-delay: 1s;\r\n  display: block;\r\n}\r\n\r\n.four.rischio2 .needle {\r\n  animation: fourspeed2 2s 1 both;\r\n  animation-delay: 1s;\r\n  display: block;\r\n}\r\n\r\n.four.rischio3 .needle {\r\n  animation: fourspeed3 2s 1 both;\r\n  animation-delay: 1s;\r\n  display: block;\r\n}\r\n\r\n.four.rischio4 .needle {\r\n  animation: fourspeed4 2s 1 both;\r\n  animation-delay: 1s;\r\n  display: block;\r\n}\r\n\r\n.MuiGrid-root.none-select::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1;\r\n  background: #191c1d;\r\n  opacity: 0.7;\r\n}\r\n\r\n.MuiGrid-root.none-select {\r\n  background: transparent;\r\n  opacity: 1;\r\n}\r\n\r\n@-webkit-keyframes fourspeed1 {\r\n  0% {\r\n    transform: rotate(0);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(16deg);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fourspeed2 {\r\n  0% {\r\n    transform: rotate(0);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(65deg);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fourspeed3 {\r\n  0% {\r\n    transform: rotate(0);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(115deg);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fourspeed4 {\r\n  0% {\r\n    transform: rotate(0);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(164deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
